// modules/NotFound.js
import React from 'react';

class NotFound extends React.Component {
	render() {
		return (
			<div className="App">
				<section className="section p-t-2">
					<div className="container">
						<div className="section__content tc">
							<h1 className="title f3 f4-md f-headline-lg m-b-0">No information available</h1>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default NotFound;


/** WEBPACK FOOTER **
 ** ./src/modules/NotFound.js
 **/